/* The list below does not contain moveable holidays that are always on sunday. */
export default {
  fixed: [
    '1.01',
    '6.01',
    '1.05',
    '3.05',
    '15.08',
    '1.11',
    '11.11',
    '25.12',
    '26.12'
  ],
  moveable: [
    '5.04.2021',
    '3.06.2021',
  ]
};
